module.exports = __webpack_public_path__ + "img/talron-location.0d1d8934.svg";